import angular from 'angular'

import VendNumber, { round } from 'vend-number'
import NgRedux from 'ng-redux'
import { ApiCustomer } from '@vend/types'
import type { VdToastNotificationService } from '../../vend-ui/types'
import { EVENT } from '../../constants'
import { customerName } from '../../filters/wr-customer-name'
import { UserManager } from '../../managers/user-manager'
import { $rootScope } from '../../ng-compat/imports'
import {
  selectCurrentSale,
  selectCurrentSaleAsSale,
  storeCreditBalanceChanged,
} from '../../state/slices/currentSale/currentSaleSlice'
import {
  CustomerBalancesManager,
  StoreCreditBalance,
} from '../../managers/customer-balances-manager'

class IssueStoreCreditCtrl {
  public awaitingServerResponse: $TSFixMe
  public customer: ApiCustomer
  public header = 'Issue store credit'
  public storeCreditData: $TSFixMe
  public storeCreditIssuedData: $TSFixMe

  constructor(
    public close: $TSFixMe,
    private options: $TSFixMe,
    private customerBalancesManager: CustomerBalancesManager,
    private userManager: UserManager,
    private vdToastNotificationService: VdToastNotificationService,
    private $ngRedux: NgRedux.INgRedux
  ) {
    'ngInject'
    this.customer = this.options.customer
    this.storeCreditData = {
      amount: null,
      notes: null,
    }
  }

  /**
   * Issues the provided store credit amount for the given customer. Also retrieves the latest store credit transactions
   * in order to show the correct store credit balance.
   *
   * @method issueStoreCredit
   */
  public issueStoreCredit() {
    this.awaitingServerResponse = true
    this.customerBalancesManager
      .issueStoreCredit(this.customer.id, this.storeCreditData)
      .then((transaction: $TSFixMe) => {
        const storeCreditIssuedData = {
          transaction,
          customer: this.customer,
          user: this.userManager.getLoggedInUser(),
        }
        // Get the latest store credit balance data for the cutomer
        return this.customerBalancesManager
          .getCustomerStoreCredit(this.customer)
          .then((storeCredit: StoreCreditBalance | null) => {
            if (!storeCredit || !storeCredit.id) {
              return null
            }
            ;(storeCreditIssuedData as $TSFixMe).storeCredit = storeCredit
            // If we have a sale with existing customer balance data, update it's store credit data
            const currentSale = selectCurrentSale(this.$ngRedux.getState())
            if (currentSale && currentSale.customerBalances) {
              this.$ngRedux.dispatch(
                storeCreditBalanceChanged(storeCredit.balance)
              )
            }
            return storeCreditIssuedData
          })
      })
      .then((storeCreditIssuedData: $TSFixMe) => {
        this.header = 'Store credit issued'
        this.storeCreditIssuedData = storeCreditIssuedData
        $rootScope.$emit(EVENT.SALE_CUSTOMER_UPDATED)
      })
      .catch(() =>
        this.vdToastNotificationService.negative({
          message: 'There was an error issuing the store credit.',
        })
      )
      .finally(() => {
        this.awaitingServerResponse = false
      })
  }

  /**
   * Responsible for triggering a store credit receipt print event.
   *
   * @method printReceipt
   */
  public printReceipt() {
    const { user, customer, transaction } = this.storeCreditIssuedData
    const { amount, created_at: date, type } = transaction
    const currentSale = selectCurrentSaleAsSale(this.$ngRedux.getState())
    const balance =
      currentSale && currentSale.customer
        ? this.customerBalancesManager.calculateStoreCreditBalance()
        : amount
    $rootScope.$emit(EVENT.PRINT, {
      type: 'store-credit-issue-receipt',
      data: {
        amount,
        balance: round(balance, 2, VendNumber.ROUNDING_MODES.ROUND_DOWN),
        customerInfo: `${customerName(customer)} (${customer.customer_code})`,
        date,
        type,
        username: user.display_name,
      },
    })
  }
}

/**
 * Controller for issuing adhoc store credit to a customer
 *
 * @module webregister.controllers.IssueStoreCreditCtrl
 */
angular
  .module('webregister.controllers')
  .controller('IssueStoreCreditCtrl', IssueStoreCreditCtrl)
